import { Link } from "react-router-dom";
import { ExternalLink, ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import { Markdown } from "@/components/Markdown";
import { Badge } from "@/components/manual/ManualIndex";
import { SectionMedia } from "@/components/manual/SectionMedia";
import { PdfButton } from "@/pages/Manual";
import { iconFor, fmtDate } from "@/components/manual/icons";

export const ManualSection = ({ s, prev, next }) => {
  const Icon = iconFor(s.icon);
  return (
    <article className="animate-rise" data-testid={`manual-section-${s.id}`}>
      <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="grid h-11 w-11 place-items-center rounded-xl bg-blue-50 text-blue-700"><Icon className="h-5 w-5" strokeWidth={1.8} /></span>
          <div>
            <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{s.group}</div>
            <h2 className="font-heading text-2xl font-semibold text-slate-900" data-testid="manual-section-title">{s.title}</h2>
          </div>
          <span className="flex"><Badge kind={s.badge} /></span>
        </div>
        <div className="flex flex-wrap gap-2">
          <PdfButton section={s.id} label="PDF sezione" testId="manual-pdf-section" />
          <Link to={s.route} data-testid="manual-open-section" className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-medium text-slate-700 transition-colors hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700">
            Apri nel pannello <ExternalLink className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
      {s.news.length > 0 && (
        <div className="mb-6 rounded-xl border border-teal-200 bg-teal-50/60 p-4" data-testid="manual-section-news">
          <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-teal-800"><Sparkles className="h-4 w-4" />Novità in questa sezione</div>
          <ul className="space-y-1.5 text-sm text-slate-700">
            {s.news.map((n, i) => <li key={i} className="flex gap-2"><span className="shrink-0 font-mono text-xs text-teal-700">v{n.version}</span><span>{n.text} <span className="text-xs text-slate-400">({fmtDate(n.date)})</span></span></li>)}
          </ul>
        </div>
      )}
      <SectionMedia s={s} />
      <Markdown text={s.body} />
      <div className="mt-10 flex justify-between gap-3 border-t border-slate-100 pt-5 text-sm">
        {prev ? <Link to={`/manuale/${prev.id}`} data-testid="manual-prev" className="inline-flex items-center gap-1 text-slate-500 hover:text-blue-700"><ChevronLeft className="h-4 w-4" />{prev.title}</Link> : <span />}
        {next && <Link to={`/manuale/${next.id}`} data-testid="manual-next" className="inline-flex items-center gap-1 text-slate-500 hover:text-blue-700">{next.title}<ChevronRight className="h-4 w-4" /></Link>}
      </div>
    </article>
  );
};
